import { render, staticRenderFns } from "./InputStandardBasic.vue?vue&type=template&id=19b5aa00"
import script from "./InputStandardBasic.vue?vue&type=script&lang=js"
export * from "./InputStandardBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports